import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { debounceTime, Subject } from 'rxjs';
import { USER_INPUT_DEBOUNCE_TIME } from '../../../../../aumico-lib-core-fe/src/lib/constants/constants';

@UntilDestroy()
@Component({
    selector: 'ham-referencing-input-component',
    templateUrl: './ham-referencing-input.component.html',
    styleUrls: ['./ham-referencing-input.component.scss'],
})
export class HamReferencingInputComponent implements OnChanges {
    @Input() isEditMode = true;
    @Input() title: string | undefined;
    private _isNumbered = false;

    @Input()
    set isNumbered(value: boolean | undefined | null) {
        this._isNumbered = value ?? false;
    }
    get isNumbered(): boolean {
        return this._isNumbered;
    }
    @Input() isReferenced: boolean | undefined;
    @Input() numbering: string | undefined;
    @Input() width: string | undefined = '600px';

    @Output() titleChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() addNumbering: EventEmitter<void> = new EventEmitter<void>();
    @Output() addReferencing: EventEmitter<void> = new EventEmitter<void>();

    isDisabled = true;

    private inputTitleSubject: Subject<string> = new Subject<string>();

    constructor() {
        this.inputTitleSubject
            .pipe(
                debounceTime(USER_INPUT_DEBOUNCE_TIME), // Adjust debounce time as needed (300ms in this case)
            )
            .subscribe((value) => {
                if (value == null || value.trim() === '') {
                    this.isDisabled = true;
                } else {
                    this.isDisabled = false;
                }
                this.title = value;
                this.titleChange.emit(value);
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['title']?.currentValue) {
            if (changes['title']?.currentValue == null || changes['title']?.currentValue.trim() === '') {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }

    onReferencingButtonClick(): void {
        this.addReferencing.emit();
    }

    onNumberingButtonClick(): void {
        this.addNumbering.emit();
    }

    onInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.inputTitleSubject.next(input.value);
    }
}
